const TELEFON_DEFAULT_REGEX = "^[+0][1-9\\s]+[0-9\\s\\-]+$";

// @vue/component
export default {
  data() {
    return {
      fields: [
        {
          key: "anrede",
          label: "_TXT_AST_BASISDATEN_PARAMETER_ANREDE_",
        },
        {
          key: "titel",
          label: "_TXT_AST_BASISDATEN_PARAMETER_TITEL_",
        },
        {
          key: "ast_vorname",
          label: "_TXT_AST_BASISDATEN_PARAMETER_VORNAME_",
        },
        {
          key: "ast_nachname",
          label: "_TXT_AST_BASISDATEN_PARAMETER_NACHNAME_",
        },
        {
          key: "ast_name",
          label: "_TXT_AST_BASISDATEN_PARAMETER_NAME_",
        },
        {
          key: "ast_namezusatz",
          label: "_TXT_AST_BASISDATEN_PARAMETER_NAMEZUSATZ_",
        },
        {
          key: "ast_strasse",
          label: "_TXT_AST_BASISDATEN_PARAMETER_STRASSE_",
        },
        {
          key: "ast_hsnr",
          label: "_TXT_AST_BASISDATEN_PARAMETER_HSNR_",
        },
        {
          key: "ast_plz",
          label: "_TXT_AST_BASISDATEN_PARAMETER_PLZ_",
        },
        {
          key: "ast_ort",
          label: "_TXT_AST_BASISDATEN_PARAMETER_ORT_",
        },
        {
          key: "bundesland",
          label: "_TXT_AST_BASISDATEN_PARAMETER_BUNDESLAND_",
        },
        {
          key: "lkz",
          label: "_TXT_AST_BASISDATEN_PARAMETER_LKZ_",
        },
        {
          key: "rechtsform",
          label: "_TXT_AST_BASISDATEN_PARAMETER_RECHTSFORM_",
        },
        {
          key: "kategorien",
          label: "_TXT_AST_BASISDATEN_PARAMETER_KATEGORIEN_",
        },
        {
          key: "ast_email",
          label: "_TXT_AST_BASISDATEN_PARAMETER_EMAIL_",
        },
        {
          key: "ast_url",
          label: "_TXT_AST_BASISDATEN_PARAMETER_URL_",
        },
        {
          key: "ast_telefon",
          label: "_TXT_AST_BASISDATEN_PARAMETER_TELEFON_",
          regex: TELEFON_DEFAULT_REGEX,
        },
        {
          key: "ast_mobil",
          label: "_TXT_AST_BASISDATEN_PARAMETER_MOBIL_",
          regex: TELEFON_DEFAULT_REGEX,
        },
        {
          key: "ast_geburtsdatum",
          label: "_TXT_AST_BASISDATEN_PARAMETER_GEBURTSDATUM_",
        },
        {
          key: "ast_geburtsort",
          label: "_TXT_AST_BASISDATEN_PARAMETER_GEBURTSORT_",
        },
        {
          key: "staatsangehoerigkeit",
          label: "_TXT_AST_BASISDATEN_PARAMETER_STAATSANGEHOERIGKEIT_",
        },
      ],
    };
  },
};
